<template>
    <generic-page>
        <div
            v-if="onboardingUser.advertiseSugarchatCreator && !isPreviewMode"
            class="alert-light border-brand-heavy branded rounded mt-3 p-3 text-center"
        >
            <img
                height="100"
                width="100"
                src="https://d1lil0eivvt84o.cloudfront.net/brand/sugarchat/logo-100.png"
            />
            <div class="d-flex align-items-center justify-content-center">
                <h5>SugarChat Grand Opening</h5>
            </div>

            <h1 class="text-success mb-0">$10,000 USD</h1>
            <b-badge variant="dark" class="text-success" pill>
                Free Credits for Cutomers
            </b-badge>

            <div class="mt-3">
                🎉 Our SugarChat brand has just launched, we are giving away
                $10,000 USD in free credits to the first 1,000 existing
                customers to join the new site
            </div>

            <div class="my-3">
                <b-btn variant="light" pill block>
                    <font-awesome-icon
                        icon="fa-light fa-check"
                        class="text-success"
                    />
                    Live Streaming
                </b-btn>
                <b-btn variant="light" pill block>
                    <font-awesome-icon
                        icon="fa-light fa-check"
                        class="text-success"
                    />
                    Content Selling
                </b-btn>
                <b-btn variant="light" pill block>
                    <font-awesome-icon
                        icon="fa-light fa-check"
                        class="text-success"
                    />
                    Posts, Gifts, Tips
                </b-btn>
                <b-btn variant="light" pill block size="">
                    <font-awesome-icon
                        icon="fa-light fa-check"
                        class="text-success"
                    />
                    Photo &amp; Video Galleries
                </b-btn>
                <b-btn variant="light" pill block size="">
                    <font-awesome-icon
                        icon="fa-light fa-check"
                        class="text-success"
                    />
                    Subscriptions
                </b-btn>
            </div>

            <b-btn
                @click="viewPreview"
                variant="primary"
                block
                pill
                size="lg"
                class="mt-3"
            >
                Join SugarChat
            </b-btn>
        </div>
        <div v-else-if="onboardingUser.advertiseEliteFilipina">
            <div class="bg-white mt-3 border-brand-heavy">
                <div class="text-center small text-secondary">
                    <font-awesome-icon icon="fa-duotone fa-ad" />
                    Findmate Network Advertisement
                </div>
                <div class="position-relative">
                    <img
                        class="img-fluid"
                        src="https://d1lil0eivvt84o.cloudfront.net/brand/elitepinay/elite-pinay-graphic.png"
                    />
                    <b-badge
                        class="float-right position-absolute"
                        style="right: 1rem; bottom: 1rem"
                        variant="dark"
                        pill
                    >
                        🎉 Launching 2026
                    </b-badge>
                </div>
                <div class="p-3">
                    <div
                        class="d-flex align-items-center justify-content-center"
                    >
                        <img
                            class="mx-2 border"
                            src="https://d1lil0eivvt84o.cloudfront.net/flag/svg/PH.svg"
                        />

                        <font-awesome-icon
                            icon="fa-duotone fa-heart"
                            size="lg"
                            class="text-danger mx-2"
                        />

                        <img
                            class="mx-2 border"
                            src="https://d1lil0eivvt84o.cloudfront.net/flag/svg/US.svg"
                        />
                    </div>

                    <h5 class="branded mt-2">
                        For Serious Filipinas who are Seeking Marriage with
                        Gentlemen from the United States
                    </h5>

                    <div class="small">
                        <div class="mt-1">
                            <font-awesome-icon
                                icon="fa-duotone fa-shield-check"
                                class="text-primary"
                            />
                            Full-background check required for all gentlemen
                        </div>

                        <div class="mt-1">
                            <font-awesome-icon
                                icon="fa-duotone fa-shield-check"
                                class="text-primary"
                            />
                            Passport required for all ladies
                        </div>

                        <div class="mt-1">
                            <font-awesome-icon
                                icon="fa-duotone fa-shield-check"
                                class="text-primary"
                            />
                            Strictly 18+ and 100% verification for all users
                        </div>

                        <div class="mt-1">
                            <font-awesome-icon
                                icon="fa-duotone fa-shield-check"
                                class="text-primary"
                            />
                            Fully IMBRA-compliant for seamless visa application
                        </div>
                    </div>

                    <b-btn
                        @click="creatorFilipinaEliteInterested"
                        variant="primary"
                        block
                        pill
                        size="lg"
                        class="mt-3"
                    >
                        Join the Waitlist
                    </b-btn>

                    <b-btn
                        @click="creatorFilipinaEliteNotInterested"
                        variant="light"
                        block
                        pill
                        size="lg"
                        class="mt-3"
                    >
                        <font-awesome-icon
                            icon="fa-light fa-times"
                            class="mr-1"
                        />
                        Not interested
                    </b-btn>
                </div>
            </div>
        </div>
        <b-alert
            variant="success"
            show
            v-if="filipinaEliteInterested"
            class="mt-3"
        >
            <font-awesome-icon icon="fa-light fa-check-circle" />
            Thanks for registering your interest. We will be launching in 2026,
            and will send you an email inviting you to join once we go live.
        </b-alert>
    </generic-page>
</template>


<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            filipinaEliteInterested: null,
        };
    },
    computed: {
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
        ...mapState("creatorDashboard", ["creatorUser"]),
        ...mapState("brand", ["brand"]),
    },
    methods: {
        creatorFilipinaEliteInterested() {
            this.api
                .post("/userFlag/creatorFilipinaEliteInterested")
                .then(() => {
                    this.filipinaEliteInterested = true;
                    this.$store.dispatch("onboarding/status");
                });
        },
        creatorFilipinaEliteNotInterested() {
            this.api
                .post("/userFlag/creatorFilipinaEliteNotInterested")
                .then(() => {
                    this.$store.dispatch("onboarding/status");
                });
        },
        viewPreview() {
            this.api.post("/broker/user").then((response) => {
                if (response?.data?.url) {
                    this.$store.dispatch(
                        "system/openBrowser",
                        response?.data?.url
                    );
                }
            });
        },
    },
    components: {},
};
</script>